import {CognitoUser} from 'amazon-cognito-identity-js';
import {createContext, useContext} from 'react';

export interface IUser extends CognitoUser {
  attributes: {
    phone_number: string;
    'custom:eth_address': string;
    sub: string;
  };
  [key: string]: any;
}

export interface IAuthState {
  currentUser: IUser | null;
  isAuthenticated: boolean;
}

export interface IAuthContext extends IAuthState {
  setAuthState: (state: IAuthState) => void;
  signOut(): void;
}

export const AuthContext = createContext<IAuthContext>({
  currentUser: null,
  isAuthenticated: false,
  setAuthState() {},
  signOut() {}
});

export const useUserContext = () => {
  const {currentUser, signOut} = useContext(AuthContext);
  return {
    userId: currentUser?.attributes.sub!,
    phoneNumber: currentUser?.attributes.phone_number!,
    ethAddress: currentUser?.attributes['custom:eth_address']!,
    signOut
  };
};
